import type { Metadata } from "@/lib/head";

import { PublicLayout } from "@/modules/landing/ui/public-header";
import { PRIVACY_DOC } from "@/modules/legal/content";
import LegalDocView from "@/modules/legal/legal-doc";
import { useSignedIn } from "@/pages/landing-session";

export const metadata: Metadata = {
  title: "개인정보 처리방침",
  description: "buildpy(빌드파이) 개인정보 처리방침(초안).",
};

export const PrivacyView = ({ signedIn }: { signedIn: boolean }) => (
  <PublicLayout signedIn={signedIn}>
    <LegalDocView doc={PRIVACY_DOC} testId="privacy-page" />
  </PublicLayout>
);

const PrivacyPage = () => <PrivacyView signedIn={useSignedIn()} />;

export default PrivacyPage;
